import $ from "jquery";

$(document).ready(() => {
  const filterProductfinder = () => {
    const selectedFunctionsString = sessionStorage.getItem(
      "selected_product_functions"
    ) || "";

    const selectedFunctions =
      selectedFunctionsString.length > 0
        ? sessionStorage.getItem("selected_product_functions").split(",")
        : [];

    let noProductsFound = true;

    $(".block__productfinder .product-category").each(function () {
      let categoryHasItems = false;
      $(this)
        .find(".product")
        .each(function () {
          const productFunctions = $(this).data("functions").split(",");
          let showProduct = true;
          if (selectedFunctions.length > 0) {
            for (const selectedFunction of selectedFunctions) {
              if (!productFunctions.includes(selectedFunction)) {
                showProduct = false;
                break;
              }
            }
          }
          if (showProduct || selectedFunctions.length === 0) {
            $(this).show();
            categoryHasItems = true;
            noProductsFound = false;
          } else {
            $(this).hide();
          }
        });
      if (categoryHasItems) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    if (noProductsFound) {
      $(".block__productfinder .no-products-found").show();
    } else {
      $(".block__productfinder .no-products-found").hide();
    }

    if (selectedFunctions.length > 0) {
      $(".block__productfinder button.delete-filters").show();
    } else {
      $(".block__productfinder button.delete-filters").hide();
    }
  };

  // Handle preselection of product functions.
  $("[data-preselect-functions]").each(function () {
    const preselectedFunctions = $(this).data("preselect-functions");
    if (preselectedFunctions.length > 0) {
      sessionStorage.setItem(
        "selected_product_functions",
        preselectedFunctions
      );
    }
  });

  // Set each product function button to selected if it was selected before in this session.
  $("button.function-selector").each(function () {
    if (sessionStorage.getItem("selected_product_functions")) {
      const functions = sessionStorage
        .getItem("selected_product_functions")
        .split(",");
      if (functions.includes($(this).data("function"))) {
        $(this).addClass("selected");
      }
    }
  });

  // Handle selection of a product function throughout site.
  $("button.function-selector").on("click", function () {
    $(this).toggleClass("selected");

    // If a function is de-selected, unselect all child selectors too.
    if (!$(this).hasClass("selected")) {
      const childSelectors = $(this).siblings("ul.function-child-selectors");
      if (childSelectors.length > 0) {
        childSelectors.find("button.function-selector").removeClass("selected");
      }
    }

    // If a child-selector is selected, unselect all siblings.
    if (
      $(this).hasClass("selected") &&
      $(this).parents("ul.function-child-selectors").length > 0
    ) {
      const selectedChildFunction = $(this).data("function");
      $(this)
        .parents("ul.function-child-selectors")
        .find("button.function-selector")
        .each(function (element) {
          if ($(this).data("function") !== selectedChildFunction) {
            $(this).removeClass("selected");
          }
        });
    }

    // Now re-write all selected filters into sessionStorage.
    const functions = [];
    $(this)
      .closest(".function-selectors")
      .find("button.function-selector.selected")
      .each(function () {
        functions.push($(this).data("function"));
      });
    sessionStorage.setItem("selected_product_functions", functions.join(","));

    filterProductfinder();
  });

  // Handle toggle of attribute groups.
  $("button.attribute-group-toggle").on("click", function () {
    $(this).toggleClass("selected");

    const targetAttributeGroup = $('[data-attribute-group='+$(this).data("target-attribute-group")+']');
    if ($(this).hasClass("selected")) {
      targetAttributeGroup.show();
    } else {
      targetAttributeGroup.hide();
    }
  });

  // Handle delete filters button.
  $("button.delete-filters").on("click", function () {
    sessionStorage.setItem("selected_product_functions", '');
    $("button.function-selector").removeClass("selected");
    filterProductfinder();
  });

  // Set attribute group toggle to selected on page-load, if any attributes  in that group are selected.
  $("button.attribute-group-toggle").each(function () {
    const targetAttributeGroup = $('[data-attribute-group='+$(this).data("target-attribute-group")+']');

    if (targetAttributeGroup.find("button.function-selector.selected").length > 0) {
      $(this).addClass("selected");
      targetAttributeGroup.show();
    }
  });

  filterProductfinder();
});
